import { useState } from 'react'

import Button from '@mui/material/Button'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import MotionDialog from '@shared/components/MotionDialog'

export default function AskLocation({
    user,
    onClose
}) {
    const [loading, setLoading] = useState(false)
    const [showSettingsHint, setShowSettingsHint] = useState(false)

    const handleAllowing = async () => {
        if (!navigator.geolocation) {
            onClose()
            return
        }

        setLoading(true)

        try {
            if (navigator.permissions?.query) {
                const permission = await navigator.permissions.query({ name: 'geolocation' })

                if (permission.state === 'denied') {
                    setShowSettingsHint(true)
                    setLoading(false)
                    return
                }
            }

            navigator.geolocation.getCurrentPosition(
                () => {
                    localStorage.setItem('allowedLocation', 'true')
                    onClose()
                },
                (error) => {
                    if (error.code === error.PERMISSION_DENIED) {
                        setShowSettingsHint(true)
                        setLoading(false)
                        return
                    }

                    setLoading(false)
                    onClose()
                },
                {
                    enableHighAccuracy: true,
                    timeout: 15000,
                    maximumAge: 0
                }
            )
        } catch (error) {
            console.error('Geolocation permission check failed:', error)

            setLoading(false)
            onClose()
        }
    }

    return (
        <MotionDialog onClose={onClose}>
        <DialogTitle>م. {user.first_name} {user.last_name}</DialogTitle>

        <DialogContent>
            <DialogContentText>
                {showSettingsHint ? (
                    <>
                        تم منع الوصول إلى موقعك من إعدادات المتصفح أو الجهاز.
                        <br />
                        <br />
                        يرجى السماح بالوصول إلى الموقع من إعدادات الجهاز، ثم
                        المحاولة مرة أخرى.
                        <br />
                        <br />

                        <strong>Android:</strong>
                        <br />
                        الإعدادات ← التطبيقات ← المتصفح ← الأذونات ← الموقع
                        <br />
                        واختر السماح أثناء استخدام التطبيق.
                        <br />
                        <br />

                        <strong>iPhone / iPad:</strong>
                        <br />
                        الإعدادات ← الخصوصية والأمان ← خدمات الموقع
                        <br />
                        ثم فعّل خدمات الموقع، وتأكد من السماح للمتصفح
                        بالوصول إلى الموقع.
                    </>
                ) : (
                    <>
                        لإضافة إحداثياتك في الصور أو إضافتها في نموذج الأصول،
                        يرجى السماح بالوصول إلى موقعك.
                    </>
                )}
            </DialogContentText>
        </DialogContent>

            <DialogActions>
                <Button
                    onClick={onClose}
                    disabled={loading}
                >
                    لاحقاً
                </Button>

                <Button
                    onClick={handleAllowing}
                    disabled={loading}
                >
                    {loading ? 'جاري التحقق...' : 'السماح'}
                </Button>
            </DialogActions>
        </MotionDialog>
    )
}
